<template>
  <pos-layout>
    <div class="h-100 orders">
      <!-- Print panel For mobile -->
      <!-- <div class="print d-md-none">
        <b-row class="d-flex h-100 no-gutters">
          <b-col class="h-100 w-100 d-md-none">
            <b-button
              :to="{ name: 'Tables', params: { id: currentOrder.table }}"
              variant="link"
              class="w-100 bg-pink"
            >
              <svg class="icon icon-icon-table">
                <use xlink:href="#icon-icon-table" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.print-to-tables-mob") }}
              </span>
            </b-button>
          </b-col>

          <b-col class="h-100 w-100">
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-1">
                <use xlink:href="#icon-icon-print-1" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.print-check") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="currentOrder.status === ORDER_STATUS.REFUNDED"
            class="h-100 w-100"
          >
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-2">
                <use xlink:href="#icon-icon-print-2" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.kitchen-print") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="currentOrder.status === ORDER_STATUS.REFUNDED"
            class="h-100 w-100 d-none d-md-block"
          >
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-3">
                <use xlink:href="#icon-icon-print-3" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.open-drawer") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="currentOrder.status !== ORDER_STATUS.CANCELLED"
            class="h-100 w-100 d-none d-md-block"
          >
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-4">
                <use xlink:href="#icon-icon-print-4" />
              </svg>

              <span>
                {{
                  currentOrder.status === ORDER_STATUS.REFUNDED ? $t("amountandpaymentmethod.credit-card") : $t("amountandpaymentmethod.show-payments")
                }}
              </span>
            </b-button>
          </b-col>

          <b-col
            v-if="!sidebarMob"
            class="h-100 w-100 d-md-none"
          >
            <b-button
              variant="link"
              class="w-100 bg-primary"
              @click="sidebarMob = true"
            >
              <svg class="icon icon-icon-mob-view">
                <use xlink:href="#icon-icon-mob-view" />
              </svg>
              <span>
                {{ $t("amountandpaymentmethod.print-view-orders-mob") }}
              </span>
            </b-button>
          </b-col>

          <b-col
            v-if="sidebarMob"
            class="h-100 w-100 d-md-none"
          />
        </b-row>
      </div> -->

      <b-row class="h-100 no-gutters customer-display-container">
        <b-col
          col
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="4"
          class="h-100 customer-display-container__left-container"
        >
          <div class="customer-display-container__left-container--sidebar">
            <div class="list">
              <div
                class="item"
                :class="{ active: selectedSection === 'customer-display' }"
                @click="selectedSection = 'customer-display'"
              >
                <p>Customer Display System</p>
              </div>
              <div
                class="item"
                :class="{ active: selectedSection === 'payment-terminal' }"
                @click="selectedSection = 'payment-terminal'"
                v-if="isShowBatchSetting"
              >
                <p>Payment Terminal</p>
              </div>
            </div>
          </div>
        </b-col>

        <b-col
          col
          cols="12"
          sm="12"
          md="7"
          lg="7"
          xl="8"
          class="h-100 orders-col order-list-container customer-display-container__right-container"
        >
          <div
            class="customer-display-container__right-container--content"
            v-if="selectedSection === 'customer-display'"
          >
            <div class="image">
              <img
                src="../assets/images/svg/cd-icon.svg"
                alt=""
              >
            </div>

            <h2>Customer Display Settings</h2>
            <p>
              Enable or disable the Customer Display System. <br>
              Ensure your Customer Display device is set to:
            </p>
            <p class="mb-4">
              Domain: <strong>{{ domainName }}</strong><br>
              Terminal: <strong>{{ terminal.id }}</strong>
            </p>

            <div class="d-flex justify-content-center align-items-center mb-4">
              <span class="mr-3 font-weight-bold">Status: {{ customerDisplayEnabled ? 'Enabled' : 'Disabled' }}</span>
              <b-form-checkbox
                :checked="customerDisplayEnabled"
                @change="toggleCustomerDisplay"
                switch
                size="lg"
              />
            </div>
          </div>

          <div
            class="customer-display-container__right-container--content"
            v-if="selectedSection === 'payment-terminal'"
          >
            <div class="image">
              <img
                src="../assets/images/svg/cd-icon.svg"
                alt=""
              >
            </div>
            <h2>Payment Terminal Management</h2>
            <p>Use this section to manage your payment terminal operations.</p>
            <b-button
              variant="primary"
              class="mb-3"
              @click="closeBatch"
            >
              Close Batch
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </pos-layout>
</template>
<script>
import PosLayout from "../layouts/PosLayout";
import {mapGetters, mapActions} from 'vuex'
import { PAYMENT_BEHAVIOR } from "@/helpers/order/payment/behavior";
export default {
    components: {
        PosLayout
    },
    data: () => ({
        code: '',
        bodyBgVariant: 'light',
        loader: {
            show: false,
            theme: 'dark'
        },
        domainName: '',
        selectedSection: 'customer-display',
        isShowBatchSetting: false
  }),
  computed: {
    ...mapGetters({
      terminal: 'config/terminal',
      baseUrl: "config/baseUrl",
      paymentTypes: 'config/paymentTypes',
      customerDisplayEnabled: "customerDisplay/isEnabled",
    }),
  },
  methods: {
    ...mapActions({
      setCustomerDisplayEnabled: 'customerDisplay/setIsEnabled',
    }),
    toggleCustomerDisplay(isEnabled) {
      this.setCustomerDisplayEnabled(!!isEnabled);
    },
    async closeBatch() {
      try {
        // Find the first payment type with NABancard integration
        const nabancardPayment = this.paymentTypes.find(pt => pt.behavior === PAYMENT_BEHAVIOR.NABANCARD_INTEGRATION);

        if (!nabancardPayment) {
          this.$bvModal.msgBoxOk('No NABancard payment type found');
          return;
        }

        const headers = new Headers({
          'Content-type': 'text/plain',
          'Host': nabancardPayment.url.replace('http://', '').replace('https://', '')
        });

        const body = `<DETAIL>
<TRAN_TYPE>CCRZ</TRAN_TYPE>
</DETAIL>`;

        const response = await fetch(nabancardPayment.url, {
          method: 'post',
          mode: 'cors',
          headers,
          body
        });

        const data = await response.text();

        // Parse the response and show appropriate message
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "text/xml");
        const responseText = xmlDoc.getElementsByTagName("AUTH_RESP_TEXT")[0]?.childNodes[0]?.nodeValue || 'Unknown response';
        const responseCode = xmlDoc.getElementsByTagName("AUTH_RESP")[0]?.childNodes[0]?.nodeValue;

        if (responseCode === "00") {
          this.$bvModal.msgBoxOk('Batch closed successfully: ' + responseText);
        } else {
          this.$bvModal.msgBoxOk('Failed to close batch: ' + responseText);
        }
      } catch (error) {
        console.error('Error closing batch:', error);
        this.$bvModal.msgBoxOk('Error closing batch: ' + error.message);
      }
    },
  },
  mounted() {
    if (this.baseUrl && this.baseUrl.includes("//")) {
      this.domainName = this.baseUrl.split("//")[1].split(".")[0];
    } else {
      this.domainName = 'dev2'; // for local development
    }

    const showBatchSetting = this.terminal.db_settings.find((item) => item.name === "show_batch");
      this.isShowBatchSetting = showBatchSetting
        ? showBatchSetting.value === "true"
        : false;
  }
}
</script>
<style lang="scss" scoped>
.customer-display-container {
  &__left-container {
    height: 100%;
    background-color: #fff;
    &--sidebar {
      height: 80vh;
      overflow-y: auto;
      background-color: #fff;
      .list {
        height: 100%;
        .item {
          padding: 20px;
          color: #007BFF;
          background-color: #fff;
          border-bottom: 1px solid #E5EAED;
          cursor: pointer;
          &.active {
            background-color: #007BFF;
            color: #fff;
          }
          p {
            margin-bottom: 0;
            font-size: 18px;
            line-height: 24px;
            text-align: left;
          }
        }
      }
    }
    @media screen and (max-width: 768px) {
      height: fit-content !important;
      &--sidebar {
        height: fit-content;
      }
    }
  }
  &__right-container {
    padding: 100px 20px;
    background-color: #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
    &--content {
      max-width: 440px;
      margin: 0 auto;
      text-align: center;
      .image {
        width: 100px;
        height: 100px;
        border-radius: 100%;
        display: block;
        margin: 0 auto 24px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
          object-fit: none;
          background-color: #007BFF1A;
        }
      }
      h2 {
        font-size: 19px;
        font-weight: 600;
        margin-bottom: 16px;
      }
      p {
        font-size: 14px;
        max-width: 384px;
        margin: 0 auto;
        line-height: 20px;
        margin-bottom: 80px;
      }
      button, .b-button {
        background-color: #007BFF;
        color: #fff;
        width: 240px;
        height: 60px;
        border: none;
        outline: none;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 40px;
        border-radius: 5px;
      }
    }
  }
}

</style>
